// src/hooks/useConfirm.js
import { useState, useCallback } from "react";
import ConfirmCalendarDialog from "../dialogs/ConfirmCalendarDialog";

export default function useConfirm() {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState({
    title: "",
    content: "",
    extra: null,
    confirmText: "Aceptar",
    cancelText: "Cancelar",
    onConfirm: null,
    onCancel: null,
    maxWidth: "xs",
    fullWidth: true,
  });

  const confirm = useCallback((cfg = {}) => {
    return new Promise((resolve, reject) => {
      setOptions({
        title: cfg.title ?? "",
        content: cfg.content ?? "",
        extra: cfg.extra ?? null,
        confirmText: cfg.confirmText ?? "Aceptar",
        cancelText: cfg.cancelText ?? "Cancelar",
        onConfirm: () => { setOpen(false); resolve(true);  cfg?.onConfirm?.(); },
        onCancel:  () => { setOpen(false); resolve(false); cfg?.onCancel?.(); },
        maxWidth: cfg.maxWidth ?? "xs",
        fullWidth: cfg.fullWidth ?? true,
      });
      setOpen(true);
    });
  }, []);

  const ConfirmDialog = (
    <ConfirmCalendarDialog
      open={open}
      title={options.title}
      content={options.content}
      extra={options.extra}
      confirmText={options.confirmText}
      cancelText={options.cancelText}
      onConfirm={options.onConfirm}
      onCancel={options.onCancel}
      maxWidth={options.maxWidth}
      fullWidth={options.fullWidth}
    />
  );

  return { confirm, ConfirmDialog };
}
